<section class="flex flex-col items-center gap-12">
  <app-section-header
    icon="@tui.globe"
    subtitle="Scalability"
    title="Scale your entire workflow"
    description="Global infrastructure built to handle millions of devices, thousands of builds, and seamless app store deployments"
  />
  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
    <div
      class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="mb-4 flex flex-row items-center">
        <tui-icon icon="@tui.server" class="mr-2" />
        <span class="text-xl font-bold md:text-2xl"
          ><span
            [countUp]="330"
            [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
            [reanimateOnClick]="false"
            >0</span
          >+</span
        >
      </div>
      <span class="text-balance text-lg">Servers deployed</span>
      <span class="text-base text-gray-500">in 125+ countries worldwide</span>
    </div>
    <div
      class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="mb-4 flex flex-row items-center">
        <tui-icon icon="@tui.database" class="mr-2" />
        <span class="text-xl font-bold md:text-2xl"
          ><span
            [countUp]="345"
            [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
            [reanimateOnClick]="false"
            >0</span
          >+ TB</span
        >
      </div>
      <span class="text-balance text-lg">Data transferred</span>
      <span class="text-base text-gray-500"
        >monthly across our global network</span
      >
    </div>
    <div
      class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="mb-4 flex flex-row items-center">
        <tui-icon icon="@tui.activity" class="mr-2" />
        <span class="text-xl font-bold md:text-2xl"
          >><span
            [countUp]="99.99"
            [options]="{
              enableScrollSpy: true,
              scrollSpyOnce: true,
              decimalPlaces: 2,
            }"
            [reanimateOnClick]="false"
            >0</span
          >%</span
        >
      </div>
      <span class="text-balance text-lg">Total uptime</span>
      <span class="text-base text-gray-500">since launch</span>
    </div>
  </div>
</section>
